import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createApi } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { OtherHelpState } from "./types";
import { baseQuery, endpoints, formatErrors, HTTP_METHODS } from "utils/api/endpoints";

export const initialState: OtherHelpState = {
    isLoading: false,
    error: null,
    data: null,
};

export const api = createApi({
  reducerPath: "otherHelpApi",
  baseQuery,
  tagTypes: ["OtherHelp"],
  endpoints: (builder) => ({
    submitOtherHelpRequest: builder.mutation<any, any>({
      query: (body) => ({
        url: endpoints.submitOtherHelpRequest.url,
        method: endpoints.submitOtherHelpRequest.method,
        body: body,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }),
    // Get other help request history
    getOtherHelpHistory: builder.query<any, any>({
      query: () => ({
        url: endpoints.submitOtherHelpRequest.url,
        method: HTTP_METHODS.GET,
      }),
      transformResponse: (response: any) => response || [],
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue.data);
      },
    }), 
  }),
})

const slice = createSlice({
  name: "otherHelp",
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const { actions: Actions } = slice;

export const useOtherHelpSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  
  return {
    actions: slice.actions,
    ...api,
  };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */ 